import { render, staticRenderFns } from "./ZakatFitrah.vue?vue&type=template&id=66accbe8&scoped=true"
import script from "./ZakatFitrah.vue?vue&type=script&lang=js"
export * from "./ZakatFitrah.vue?vue&type=script&lang=js"
import style0 from "./ZakatFitrah.vue?vue&type=style&index=0&id=66accbe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66accbe8",
  null
  
)

export default component.exports